import React from "react";
import { useTranslation } from "react-i18next";

export function TitleWrapper() {
    const { t } = useTranslation();

    return <h4 className="mr-3">{t("Shops")}</h4>;
}
